exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".apply .wrapper .application .app-display .left-side .info .inputs input[type=text].ssn-input{box-shadow:none}.apply .wrapper .application .app-display .left-side .info .inputs input.ssn-input{max-width:480px;width:90%;border:2px solid #cfcfd2;border-radius:2px;font-family:Open Sans,sans-serif;font-size:14px;padding:7px 8px;background:#fff;margin-top:7px;margin-bottom:5px;color:#545454;display:inline-block}.apply .wrapper .application .app-display .left-side .info .inputs .show-button{margin-left:5px;display:inline-block;cursor:pointer;color:#337ab7}@media (max-width:768px){.apply .wrapper .application .app-display .left-side .info .inputs input.ssn-input{width:70%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!./directives/freeforms/ssn/ssn.css
// module id = 374
// module chunks = 0